import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  Stack,
  Typography,
  InputAdornment,
  IconButton,
  TextField,
  Alert,
} from '@mui/material';

import { LoadingButton } from '@mui/lab';
import { FormProvider, RHFSwitch, RHFTextField } from 'src/components/hook-form';
import { Controller, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';


import CancelIcon from '@mui/icons-material/Cancel';
import useLocales from 'src/hooks/useLocales';
import { useStore } from 'src/stores/store';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useEffect, useMemo } from 'react';
import Iconify from 'src/components/Iconify';
import { IAttachment } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';

interface Props {
  id: number;
}

export default observer(function ContractInfoAttachment({ id }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const { translate } = useLocales();
  const { ContractInfoStore } = useStore();
  const { selectedContractInfoDetail } = ContractInfoStore;
  const validationSchema = Yup.object().shape({
    // file: Yup.string(),
  });

  const defaultValues = useMemo<IAttachment>(
    () => ({
      contractId: selectedContractInfoDetail?.contractId,
      // file: selectedContractInfoDetail?.file,
    }),
    [selectedContractInfoDetail]
  );
  const methods = useForm<any>({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    watch,
    setValue,
    setError,
    formState: { isSubmitting,errors },
  } = methods;

  const onSubmit = (data: IAttachment) => {
    ContractInfoStore.Attachment(data)
      .then(() => {
        ContractInfoStore.setOpenCloseAttachmentDialog();
        enqueueSnackbar(`${translate('Tostar.UpaloadSuccess')}`);
      })
      .catch((err) => {
        var json = JSON.parse(err.request.response);
        if (json.error != null) {
          setError('afterSubmit', { ...err, message: json.message });
        }
     
      });
  };

  useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);



  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
       {!!errors.afterSubmit && (
        <Alert sx={{ mb: 2 }} severity="error">
          {errors.afterSubmit.message}
        </Alert>
      )}
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={10} md={10}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              
              }}
            >
              {/* Content */}

              <Stack spacing={2} sx={{ mb: 2 }}>
                <>
                  {/* Hidden File Input */}
                  <input
                    type="file"
                    // accept=".jpg"
                    id="contractattachment"
                    onChange={(e) => {
                      const file = e.target.files ? e.target.files[0] : null;
                      setValue('attachment', file);
                    }}
                    style={{ display: 'none' }}
                  />

                  {/* TextField with Attachment Icon */}
                  <TextField
                    label="Attach File"
                    value={watch('attachment')?.name || ''} // Display file name
                    placeholder="No file chosen"
                    InputProps={{
                      readOnly: true, // Prevent manual input
                      startAdornment: (
                        <InputAdornment position="start">
                          {/* Attachment Icon */}
                          <label htmlFor="contractattachment">
                            <IconButton component="span">
                              <AttachFileIcon />
                            </IconButton>
                          </label>
                        </InputAdornment>
                      ),
                    }}
                    fullWidth
                    size="medium"
                    sx={{ m: 1, width: '100%' }}
                  />
                </>

              
              </Stack>
              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color="success"
                  loading={isSubmitting}
                  startIcon={<Iconify icon="eva:edit-fill" />}
                >
                  {translate('CRUD.Save')}
                </LoadingButton>

                <LoadingButton
                  variant="contained"
                  size="small"
                  onClick={() => ContractInfoStore.setOpenCloseAttachmentDialog()}
                  startIcon={<CancelIcon />}
                >
                  {translate('CRUD.Cancle')}
                </LoadingButton>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </FormProvider>
  );
});
